import { Box, Button, Modal, Typography } from "@mui/material";
import { useTipos } from "../../../../context/SuperAdmin/OASContexts/TiposContext";

const DeleteTiposModal = () => {
  const {
    selectedTipos,
    isDeleteTipoModalOpen,
    isDeletingTipo,
    toggleDeleteTipoModal,
    tipoDelete,
  } = useTipos();

  const handleClose = () => {
    if (!isDeletingTipo) {
      toggleDeleteTipoModal(false);
    }
  };

  const handleSubmit = () => {
    const body = { ids: selectedTipos };
    tipoDelete(body);
  };
  return (
    <Modal
      open={isDeleteTipoModalOpen}
      onClose={handleClose}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: "rgba(0, 0, 0, 0.3)", // Fondo negro con opacidad
      }}
    >
      <Box
        component={"div"}
        sx={{
          width: 400,
          bgcolor: "background.paper", // Fondo blanco del modal
          borderRadius: 2, // Bordes redondeados
          p: 4,
          boxShadow: 24,
          minWidth: "600px",
          display: "flex",
          flexDirection: "column",
          gap: 3,
        }}
      >
        <Typography component={"h3"} sx={{ fontSize: "20px", fontWeight: 600 }}>
          Eliminar {selectedTipos.length}{" "}
          {selectedTipos.length > 1 ? "tipos" : "tipo"}
        </Typography>
        <Typography component={"p"}>
          La organización perderá estos tipos así como los objetivos
          relacionados.
        </Typography>
        <Box
          sx={{
            textAlign: "right",
            display: "flex",
            justifyContent: "flex-end",
            gap: 3,
          }}
        >
          <Button
            variant="outlined"
            onClick={() => toggleDeleteTipoModal(false)}
            disabled={isDeletingTipo}
            sx={{
              borderRadius: 14,
              border: "1px solid #336B87",
              color: "#336B87",
              "&:hover": {
                backgroundColor: "#336B87",
                color: "#EEF3F6",
              },
            }}
          >
            Cancelar
          </Button>
          <Button
            variant="contained"
            sx={{ background: "#336B87" }}
            disabled={isDeletingTipo}
            onClick={handleSubmit}
          >
            Confirmar
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default DeleteTiposModal;
